import { Injectable } from '@angular/core';

/** Default dropdown configuration */
@Injectable()
export class PmdDropdownConfig {
  /** default dropdown auto closing behavior */
  autoClose = true;
}
